import React, { Component } from "react";
import { FiX , FiMenu} from "react-icons/fi";
import Scrollspy from 'react-scrollspy'
import { SocialShare } from "../../constants/socialInfo";
import { withTranslation } from 'react-i18next';


class HeaderThree extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded');
        })
        
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader () {}

    render(){

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const {  t, color='default-color', detailsProject, updateGlobalSate } = this.props;
        const constHref = "#"
        const linkCv = t('cv').indexOf('Mon') > -1 ? 'https://cv-documents.s3.amazonaws.com/cv_Sami_GHORBEL_FR_latest.pdf' : 'https://cv-documents.s3.amazonaws.com/cv_Sami_GHORBEL_EN_latest.pdf'
        return(
            <header className={`header-area header-style-two header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <nav className="mainmenunav d-lg-block ml--50">
                            <Scrollspy className="mainmenu" items={['home','about','portfolio','contact']} currentClassName="is-current" offset={-200}>
                                <li onClick={() => updateGlobalSate()}><a href={constHref}>{t('header_home')}</a></li>
                                {!detailsProject && <li><a href="#about">{t('header_about')}</a></li>}
                                {/* {!detailsProject && <li><a href="#portfolio">{t('header_projects')}</a></li>} */}
                                {!detailsProject && <li><a href="#contact">{t('header_contact')}</a></li>}
                                <li onClick={() => updateGlobalSate()}><a href={linkCv} target="_blank" rel="noopener noreferrer">{t('cv')}</a></li>
                            </Scrollspy>
                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="social-share-inner">
                            <ul className="social-share social-style--2 color-black d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default withTranslation() (HeaderThree);
